import React from "react"

export default (color: string) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50.12"
    height="64.615"
    viewBox="0 0 50.12 64.615"
  >
    <g id="noun_test_1676486" transform="translate(-25.446 -18.173)">
      <path
        id="Path_13"
        data-name="Path 13"
        d="M65.231,82.788H35.73a10.3,10.3,0,0,1-9.339-14.609l3.8-8.208H48.865a2.019,2.019,0,1,0,0-4.038H32.055l3.271-7.067H48.865a2.019,2.019,0,1,0,0-4.038H37.194l3.19-6.976V37.76h8.481a2.019,2.019,0,1,0,0-4.038H40.385V22.212H38.658a2.019,2.019,0,1,1,0-4.038H62.3a2.019,2.019,0,1,1,0,4.038H60.577V37.85L74.6,68.139a10.3,10.3,0,0,1-9.369,14.65Z"
        fill={`${color}`}
      />
    </g>
  </svg>
)
